import { render, staticRenderFns } from "./ProductRelatedProducts.vue?vue&type=template&id=6b0b422e&scoped=true"
import script from "./ProductRelatedProducts.vue?vue&type=script&lang=js"
export * from "./ProductRelatedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b422e",
  null
  
)

export default component.exports